import request from '@/utils/request'

const http = {
    /**
     * methods: 请求
     * @param url 请求地址 
     * @param params 请求参数
     */
    get (url, params, headers = {}) {
        const config = {
            method: 'get',
            url: url,
            retry: 5,
            retryDelay: 1000,
            timeout: 6000
        }
        if (params) config.params = params
        if (headers) config.headers = headers
        request(config)
            .then(function (response) {
                return response.data
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    post (url, params, headers = {}) {
        const config = {
            method: 'post',
            url: url,
            retry: 5,
            retryDelay: 1000,
            timeout: 6000
        }
        if (params) config.data = params
        if (headers) config.headers = headers
        return request(config)
    }
}
// =============================================================================
// 充值页面接口
// =============================================================================
export function RequestPayQRcode (data) {
    return http.post('/PayPage/request_pay', data)
}

export function GetPayPageZoneList (data) {
    return http.post('/PayPage', data)
}

export function GetOrderState (data) {
    return http.post('/PayPage/check_order', data)
}